import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { merge, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SearchBarDialogComponent } from './search-bar-dialog/search-bar-dialog.component';

@Component({
  selector: 'wsg-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBarComponent implements OnDestroy {

  // == ACTIONS ====================================================

  openSearchDialog = new Subject();
  openSearchDialog$ = this.openSearchDialog.asObservable();

  // == SIDE EFFECTS ===============================================

  onOpenSearchDialog$ = this.openSearchDialog$.pipe(
    tap(() => this.dialog.open(SearchBarDialogComponent))
  );

  // == SUBSCRIPTION ===============================================

  subscription = merge(
    this.onOpenSearchDialog$
  ).subscribe();

  // == LIFECYCLE ==================================================

  constructor(private dialog: MatDialog) { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
